import React, { Component } from "react";
import { Pagination, Loading } from "@alife/next";
import $ from "jquery";
import Offer from "./zrOffer";
import { connect } from "@alife/tarot";
import goldlog from "@ali/goldlog";
import ClassNames from "classnames";
import Util from "../../util/common";
import NewOffer from "./zrBackupOffer";

window.jplus || (window.jplus = {});
window.jplus.plugin || (window.jplus.plugin = {});
window.jplus.plugin.exp || (window.jplus.plugin.exp = []);

window.jplus.plugin.exp.push({
  config: {
    selector: ".offer_exp",
    visible: "0.3",
    duration: "300",
    propsMap: {
      url: "data-jplus-exp-url",
    },
  },
  expWillRecord: (...obj) => {
    // console.log(obj);
    const target = obj[1];
    const targetAttr = obj[2] || "";
    if (targetAttr["data-jplus-exp-url"]) {
      //
      goldlog.record(
        "/btob.wxb.pcsem_exp_pre",
        "EXP",
        `offerReport=${target["data-aplus-report"]}`,
        "GET"
      );
      /*const exp_url = targetAttr["data-jplus-exp-url"];
       const img = new Image();
       img.src =exp_url;
       target.setAttribute("data-jplus-exp","true")*/
      // goldlog.record('/btob.wxb.pcsem_exp_did','EXP',`offerReport=${target["data-aplus-report"]}`,'GET')
      return obj[0];
    }
  },
  // expDidRecord:(...obj) => {
  //   const target = obj[2] || "";
  //   goldlog.record('/btob.wxb.pcsem_exp_did','EXP',`offerReport=${target["data-aplus-report"]}`,'GET')
  // },
});

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

class List extends Component {
  constructor(opts) {
    super(opts);
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.getFormatIds = this.getFormatIds.bind(this);
  }

  getFormatIds(list) {
    const resultIds =
      list.reduce((ret, item) => {
        ret.push(`${item.offerid}:${item.memberId}`);
        return ret;
      }, []) || [];
    return resultIds.join(",");
  }

  pageChange(current) {
    window.scrollTo(0, 220);
    const { dispatch } = this.props;
    //清空上次数据
    dispatch("offer/resetList");

    dispatch("offer/setParams", {
      beginpage: current,
      asyncreq: 1,
    });
    //设置背景loading
    dispatch("offer/setValues", {
      bodyLoading: true,
      isEnd: false,
    });
    dispatch("offer/getList", {
      beginpage: current,
      asyncreq: 1,
    });

    window.__WPO.log(`turn_page_${pageConfig.keywords}_${current}`, 1);
    goldlog.record(
      "/szyx.pc_sem.turn_page",
      "CLK",
      `keyword=${pageConfig.keywords}&count=${current}`,
      "GET"
    );
  }

  getData() {
    const { dispatch, formParams, isLoading } = this.props;
    if (formParams.asyncreq > 6) {
      return false;
    }
    dispatch("offer/setParams", {
      keywords: pageConfig.keywords,
    });
    if (!isLoading) {
      dispatch("offer/getList");
    }
  }

  componentDidMount() {
    // DotLog1({})
    // DotLog({
    // 	area: [{
    // 		selector: '.offer_list'
    // 	}]
    // });
    const self = this;
    const { dispatch, formParams } = this.props;
    //首屏直出
    if (
      this.props.listOffer &&
      this.props.listOffer.length > 0 &&
      formParams.beginpage == 1
    ) {
      dispatch("offer/setValues", {
        list: this.props.listOffer,
      });
      dispatch("offer/setParams", {
        asyncreq: 2,
      });
      //
      const reqIds = this.getFormatIds(this.props.listOffer);
      dispatch("mkc/getList", {
        offerMemberPairs: reqIds,
      });
    }

    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      const w_h = $(window).height();
      const _top = $("#offerList").offset().top;
      const _content_h = $("#offerList").height();
      // 调节区 增大
      const _h = 550;
      if (scrollTop + w_h + _h >= _content_h + _top - w_h) {
        const { isEnd } = self.props;
        if (!isEnd) {
          // debugger;
          self.getData();
        }
      }
    });

    const obj = Util.getUrlParms();

    const t1 = window.setInterval(() => {
      if (Util.getPvid()) {
        window.clearInterval(t1);
        dispatch(
          "offer/setParams",
          Object.assign(obj, {
            pageid: Util.getPvid(),
            p4pid: p4pObject.p4pid,
          })
        );
        //现发一个首屏数据的请求
        dispatch("offer/getHomeList", {
          asyncreq: 1,
        });
        this.getData();
      }
    }, 20);
  }

  componentDidUpdate() {
    window.Light && window.Light.init();
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    const { reqOnlyList } = nextProps;
    if (reqOnlyList && reqOnlyList.length > 0) {
      const reqIds = this.getFormatIds(reqOnlyList);
      //回归状态
      dispatch("offer/setReqOnlyList", {
        reqOnlyList: [],
      });
      dispatch("mkc/getList", {
        offerMemberPairs: reqIds,
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch("offer/resetData");
    dispatch("mkc/resetData");
  }

  render() {
    const { list } = this.props;
    const { width = 1190, formParams } = this.props;

    const clswarp = ClassNames({
      bg_gray: true,
      clearfix: true,
      over_hid: true,
      w_1190: width === 1190,
      w_990: width === 990,
      w_1390: width === 1390,
    });

    const cls_list = ClassNames({
      mt20: true,
      over_hide: true,
      w_1210: width === 1190,
      w_1420: width === 1390,
      w_1024: width === 990,
      offer_list: true,
    });
    const { bodyLoading = false } = this.props;
    const mockInfo = this.props.mkc.mkcInfo || {};

    return (
      <div className={clswarp} id="offerList" data-spm="dh_002">
        <Loading tip="" visible={bodyLoading}>
          <div className={cls_list}>
            {list.map((item, index) => {
              const mkc = mockInfo[item.offerid] || null;
              item.isPcSem = true;
              return item.zhurong ? (
                <Offer
                  key={index}
                  index={parseInt(formParams.beginpage - 1) * 120 + index}
                  data={item}
                  mkc={mkc}
                />
              ) : (
                <NewOffer
                  key={index}
                  index={parseInt(formParams.beginpage - 1) * 120 + index}
                  data={item}
                  mkc={mkc}
                />
              );
            })}
          </div>
          <div className="txt_center">
            <Pagination
              pageSizeSelector={false}
              current={parseInt(formParams.beginpage)}
              pageSize={120}
              total={50 * 120}
              size="large"
              onChange={this.pageChange}
            />
          </div>
        </Loading>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.offer,
  mkc: state.mkc,
});
export default connect(mapStateToProps)(List);
